import(/* webpackMode: "eager" */ "C:\\Users\\dhux6\\OneDrive\\Documents\\Dev\\ghostnet-commece\\app\\checkout\\page.jsx")